// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1kTu4","vLegacy":"SelectSecondary_vLegacy__2FzDY","error":"SelectSecondary_error__36IDv","disabled":"SelectSecondary_disabled__P1PVg"};